import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface PopupRequest {
    category: string;
    limit: string;
    page: number;
}
export type DataListProps = {
    idx: number;
    vPopSizeW: string;
    vPopSizeH: string;
    vPopX: string;
    vPopY: string;
    cViewYN: string;
    cTodayYN: string;
    cPvL: string;
    vContent: string;
};

export interface PopupResponseData {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetConsolePopups = ({ category, page, limit }: PopupRequest): UseQueryResult<PopupResponseData, Error> => {
    let url = enum_api_uri.get_console_popups.replace(":category", category);
    return useQuery({
        queryKey: ["useGetConsolePopups", page, limit],
        queryFn: async () => {
            const response = await axiosInstance.get(url, {
                params: {
                    page,
                    limit,
                },
            });
            return response.data.data;
        },
    });
};
